import {
  enumSliderControl,
  enumSliderDirection,
  kOCNTextColor,
  kTickSliderColor,
  kTriangleHeight,
  kTriangleOffset,
  kTriangleWidth
} from "../constants";
import { QElement } from "./QElement";
import { QSliderKnob } from "./QSliderKnob";
import { ThicknessAdjuster } from "../utils/ThicknessAdjuster";
import { SetCtxFont } from "../utils/SetCtxFont.js";

export class QSlider extends QElement {
  constructor() {
    super();
    this.fMinVal = 0;
    this.fPrecision = 0;
    this.fSliderKnobList = null;
    this.fActiveKnob = null;
    this.fKnobOffset = 0;
    this.fLabels = null;

    this.fSliderType = enumSliderControl.knob;

    this.fSliderColor = "#00FF00";
    this.fSliderDirection = enumSliderDirection.pointsUp;
  }

  InitSlider(xStart, yStart, width, theHeight) {
    var xPos = xStart - kTriangleOffset;
    var fullWidth = width + kTriangleWidth;

    if (theHeight == null) theHeight = kTriangleHeight + 2;

    this.PositionElement(xPos, yStart);
    this.SizeElement(fullWidth, theHeight);
    this.SetIsControl(true);

    this.SetGenerateInteractiveCmd(true);
    //	this.SetRange(0,width);
  }

  GetMinValue() {
    return this.fMinVal;
  }

  SetMinValue(minVal) {
    this.fMinVal = minVal;
  }

  SetSliderType(silderType) {
    this.fSliderType = silderType;
  }

  AddSliderKnob(startPosition) {
    if (this.fSliderKnobList == null) this.fSliderKnobList = new Array();

    var aKnob = new QSliderKnob();
    aKnob.SetPosition(startPosition + kTriangleOffset);
    this.fSliderKnobList.push(aKnob);
  }

  GetKnobPosition(index) {
    var aKnob = this.fSliderKnobList[index];
    var knobPosition = aKnob.GetPosition() - kTriangleOffset;

    return knobPosition;
  }

  SetKnobPosition(index, position) {
    var aKnob = this.fSliderKnobList[index];
    aKnob.SetPosition(position + kTriangleOffset);
  }

  StartInteractWithElement(canvasX, canvasY, panelX, panelY, shiftDown) {
    var numKnobs = 0;
    var localX = panelX - this.fHorzOffset;

    if (this.fSliderKnobList != null) numKnobs = this.fSliderKnobList.length;

    for (var i = 0; i < numKnobs; i++) {
      var aKnob = this.fSliderKnobList[i];

      if (aKnob.GrabTest(localX)) {
        this.fActiveKnob = aKnob;
        this.fKnobOffset = aKnob.GetClickOffset(localX);
        return true;
      }
    }

    return false;
  }

  DoInteractWithElement(x, y) {
    var activeKnob = this.fActiveKnob;
    var rightBarrier = activeKnob.GetRightBarrier();
    var adjRight = rightBarrier + kTriangleOffset - this.fKnobOffset;

    if (rightBarrier != -1) {
      if (x > adjRight) x = adjRight;
    }

    var leftBarrier = activeKnob.GetLeftBarrier();
    var adjLeft = leftBarrier + kTriangleOffset - this.fKnobOffset;

    if (leftBarrier != -1) {
      if (x < adjLeft) x = adjLeft;
    }

    activeKnob.SetPosition(x + this.fKnobOffset);
  }

  DoSetSelected(priorState, selected) {
    if (selected) console.log("Hmmm");
  }

  InteractWithElement(x, y) {
    var adjustX = x - this.fHorzOffset;
    var maxWidth = this.fWidth - kTriangleOffset - this.fKnobOffset;
    var minWidth = kTriangleOffset - this.fKnobOffset + this.GetMinValue();

    var index = this.fSliderKnobList.indexOf(this.fActiveKnob);
    var numKnobs = this.fSliderKnobList.length;

    if (index == 0) {
      if (adjustX < minWidth) adjustX = minWidth;
    }

    if (index == numKnobs - 1) {
      if (adjustX > maxWidth) adjustX = maxWidth;
    }

    if (index > 0) {
      var prevKnob = this.fSliderKnobList[index - 1];
      var prevPos = prevKnob.GetPosition() + kTriangleWidth - this.fKnobOffset;
      if (adjustX < prevPos) adjustX = prevPos;
    }

    if (index < numKnobs - 1) {
      var nextKnob = this.fSliderKnobList[index + 1];
      var nextPos = nextKnob.GetPosition() - kTriangleWidth - this.fKnobOffset;
      if (adjustX > nextPos) adjustX = nextPos;
    }

    this.DoInteractWithElement(adjustX, y);
  }

  SetSliderColor(sliderColor) {
    this.fSliderColor = sliderColor;
  }

  SetSliderDirection(sliderDirection) {
    this.fSliderDirection = sliderDirection;
  }

  // This is not a holistic solution...
  SetSliderLabel(label, justification, knobIndex) {
    this.fSliderKnobList[knobIndex].SetLabel(label);
    this.fSliderKnobList[knobIndex].SetLabelJust(justification);
  }

  DrawAxis(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");

    ctx.save();
    ctx.strokeStyle = kTickSliderColor;

    var thickness = 1;
    ctx.lineWidth = thickness;
    ctx.lineCap = "square";

    var t0x = this.fHorzOffset + ThicknessAdjuster(thickness) + kTriangleOffset;
    var t0y =
      this.fVertOffset + Math.floor(this.GetHeight() / 2) - 1 + ThicknessAdjuster(thickness);
    var t1x = t0x + this.GetWidth() - kTriangleOffset * 2;
    var t1y = t0y;

    ctx.beginPath();
    ctx.moveTo(t0x, t0y);
    ctx.lineTo(t1x, t1y);
    ctx.closePath();

    ctx.stroke();
    ctx.restore();
  }

  DrawTick(drawBuffer, aKnob) {
    var ctx = drawBuffer.getContext("2d");

    ctx.save();
    ctx.strokeStyle = kTickSliderColor;

    var thickness = 3;
    ctx.lineWidth = thickness;
    ctx.lineCap = "square";

    var controlTop = this.fVertOffset + 1 + ThicknessAdjuster(thickness);
    var sliderPos = this.fHorzOffset + aKnob.GetPosition() + ThicknessAdjuster(thickness);

    var t0x = sliderPos;
    var t0y = controlTop;
    var t1x = sliderPos;
    var t1y = t0y + this.GetHeight() - 4;

    ctx.beginPath();
    ctx.moveTo(t0x, t0y);
    ctx.lineTo(t1x, t1y);
    ctx.closePath();

    ctx.stroke();
    ctx.restore();
  }

  DrawKnob(drawBuffer, aKnob) {
    var ctx = drawBuffer.getContext("2d");

    ctx.save();
    ctx.strokeStyle = "#000000";
    ctx.fillStyle = this.fSliderColor;
    ctx.lineWidth = 2;
    ctx.lineJoin = "miter";

    var controlTop = this.fVertOffset;
    var theLabel = aKnob.GetLabel();

    // Draw slider based on fCurrentVal
    var sliderPos = this.fHorzOffset + aKnob.GetPosition();
    var t0x, t0y, t1x, t1y, t2x, t2y;
    var labelY;

    if (this.fSliderDirection == enumSliderDirection.pointsDown) {
      t0x = sliderPos;
      t0y = controlTop + kTriangleHeight;
      t1x = t0x + kTriangleOffset;
      t1y = t0y - kTriangleHeight;
      t2x = t0x - kTriangleOffset;
      t2y = t0y - kTriangleHeight;
      labelY = t0y - kTriangleHeight - 6;
    } else {
      t0x = sliderPos;
      t0y = controlTop;
      t1x = t0x + kTriangleOffset;
      t1y = t0y + kTriangleHeight;
      t2x = t0x - kTriangleOffset;
      t2y = t0y + kTriangleHeight;
      labelY = t0y + kTriangleHeight + 6;
    }

    ctx.beginPath();
    ctx.moveTo(t0x, t0y);
    ctx.lineTo(t1x, t1y);
    ctx.lineTo(t2x, t2y);
    ctx.lineTo(t0x, t0y);
    ctx.closePath();

    ctx.stroke();
    ctx.fill();

    if (theLabel.length > 0) {
      ctx.textBaseline = "middle";
      ctx.textAlign = aKnob.GetLabelJust();
      //ctx.font="11px Verdana";
      SetCtxFont(ctx, "11px Verdana");

      ctx.fillStyle = kOCNTextColor;
      ctx.fillText(theLabel, t0x, labelY);
    }

    ctx.restore();
  }

  DoRenderElement(drawBuffer) {
    var numKnobs = 0;
    if (this.fSliderKnobList != null) numKnobs = this.fSliderKnobList.length;

    if (this.fSliderType != enumSliderControl.knob) this.DrawAxis(drawBuffer);

    for (var i = 0; i < numKnobs; i++) {
      var aKnob = this.fSliderKnobList[i];
      //if (aKnob != this.fActiveKnob)
      if (this.fSliderType == enumSliderControl.knob) this.DrawKnob(drawBuffer, aKnob);
      else this.DrawTick(drawBuffer, aKnob);
    }
  }

  SetCmdParameters(aCmd) {
    if (this.fActiveKnob != null) {
      var index = this.fSliderKnobList.indexOf(this.fActiveKnob);
      aCmd["KnobIndex"] = index;
      aCmd["KnobValue"] = this.fActiveKnob.GetValue();
    } else {
      // I guess the events can be queued such that activeknob has gone null by the time we get here??
      //console.log("Active Knob is null");
    }
  }

  SetLeftBarrier(index, x) {
    var aKnob = this.fSliderKnobList[index];
    aKnob.SetLeftBarrier(x);
  }

  SetRightBarrier(index, x) {
    var aKnob = this.fSliderKnobList[index];
    aKnob.SetRightBarrier(x);
  }
}
